import Cookies from 'js-cookie';
import actions from './actions';

const {
    LOGIN_BEGIN,
    LOGIN_SUCCESS,
    LOGIN_ERR,
    LOGOUT_BEGIN,
    LOGOUT_SUCCESS,
    LOGOUT_ERR,
} = actions;

const getSavedLoginData = () => {
    const savedData = Cookies.get('SangLoggedData');

    if (!savedData) {
        return '';
    }

    try {
        return JSON.parse(savedData);
    } catch (error) {
        Cookies.remove('SangLoggedData');
        return '';
    }
};

const initState = {
    login: Cookies.get('SangLoggedIn') || '',
    loading: false,
    error: null,
    loginData: getSavedLoginData(),
};

const authReducer = (state = initState, action) => {
    const { type, data, loginData, err } = action;

    switch (type) {
        case LOGIN_BEGIN:
            return {
                ...state,
                error: '',
                login: '',
                loginData: '',
                loading: true,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                login: data,
                loginData,
                loading: false,
            };
        case LOGIN_ERR:
            return {
                ...state,
                error: err,
                login: '',
                loginData: '',
                loading: false,
            };
        case LOGOUT_BEGIN:
            return {
                ...state,
                error: '',
                loading: true,
            };
        case LOGOUT_SUCCESS:
            return {
                ...state,
                error: '',
                login: '',
                loginData: '',
                loading: false,
            };
        case LOGOUT_ERR:
            return {
                ...state,
                error: err,
                login: '',
                loginData: '',
                loading: false,
            };
        default:
            return state;
    }
};

export { authReducer };
